import { IconWrapper } from '../runtime';
export default IconWrapper('underscore', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.25 1.74976V6.99976C12.25 9.34697 10.3472 11.2498 8 11.2498C5.65279 11.2498 3.75 9.34697 3.75 6.99976V1.74976M3.25 14.2498H12.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});